import { DatatableRowData, SubSectionData } from "@/domain/view/components/datatable/datatable-types";
import { Row } from "@tanstack/react-table";

import { User } from "../../models/user-model";
import { UserViewOptional } from "../user-view-optional";

export interface DatatableAssigneeSubSectionHeaderProps<TData extends DatatableRowData> {
  data: SubSectionData<TData>;
  currentRow: Row<SubSectionData<TData>>;
  user?: User | null;
}

export const DatatableAssigneeSubSectionHeader = <TData extends DatatableRowData>({
  currentRow,
  user,
}: DatatableAssigneeSubSectionHeaderProps<TData>) => {
  const count = currentRow.subRows.length;

  return (
    <div className="flex h-full flex-row items-center justify-start gap-2 px-2">
      <div className="flex flex-row items-center justify-start gap-2">
        <UserViewOptional user={user} logoOnly={false} className="h-3.5 w-3.5" />
        <span className="text-xs text-muted-foreground">{count}</span>
      </div>
      <div className="flex grow flex-row items-center pl-2">
        <div className="h-px w-full bg-foreground/10" />
      </div>
    </div>
  );
};
